import { Component } from '@angular/core';
import { membersuiteOrderEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Orders') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuiteorder-form',
    templateUrl: './membersuiteorder.form.component.html'
})
export class membersuiteOrderFormComponent extends BaseFormComponent {
    public record!: membersuiteOrderEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

